export const HOTSPOT_BASE_SIZE = 51.2

export const SOCIAL = {
  FETCH_COMMENTS_COUNTS_EACH_TIME: 10,
  BASIC_FOLDER: 'social',
  COMMENT_COUNT: 'commentCount',
  LIKE_COUNT: 'likeCount',
  VIEW_COUNT: 'viewCount',
  COMMENTS: 'comments'
}
export const VISITOR = {
  BASIC_FOLDER: 'social',
  USER: 'user',
  VIEW_COUNT: 'viewCount',
  VIEW_LAST_TIME: 'viewLastTime',
  VIEW_SESSION_SEC: 'viewSessionSec'
}

export const WEBINAR = {
  BASIC_FOLDER: 'webinar'
}

export const CATEGORYNAMES = {
  livingroom: 'livingroom',
  diningroom: 'diningroom',
  kitchen: 'kitchen',
  bedroom: 'bedroom',
  study: 'study',
  bathroom: 'bathroom',
  toilet: 'toilet',
  garden: 'garden',
  garage: 'garage',
  outdoors: 'outdoors',
  others: 'others',
  custom: 'custom'
}

export const CATEGORIES = [{
  value: CATEGORYNAMES.livingroom,
  text: 'categories.livingroom'
}, {
  value: CATEGORYNAMES.diningroom,
  text: 'categories.diningroom'
}, {
  value: CATEGORYNAMES.kitchen,
  text: 'categories.kitchen'
}, {
  value: CATEGORYNAMES.bedroom,
  text: 'categories.bedroom'
}, {
  value: CATEGORYNAMES.study,
  text: 'categories.study'
}, {
  value: CATEGORYNAMES.bathroom,
  text: 'categories.bathroom'
}, {
  value: CATEGORYNAMES.toilet,
  text: 'categories.toilet'
}, {
  value: CATEGORYNAMES.garden,
  text: 'categories.garden'
}, {
  value: CATEGORYNAMES.garage,
  text: 'categories.garage'
}, {
  value: CATEGORYNAMES.outdoors,
  text: 'categories.outdoors'
}, {
  value: CATEGORYNAMES.others,
  text: 'categories.others'
}, {
  value: CATEGORYNAMES.custom,
  text: 'categories.custom'
}]

export const POPUP = {
  TYPE: 'marker', // marker / intro
  FULL_HEIGHT: false,
  WIDTH_PERCENT: 65,
  TRANSPARENT: false
}
export const INTRO_TYPE = {
  BUILDING: 'BUILDING',
  TOURRING: 'TOURRING'
}
export const COMPANY = {
  YUNG_CHING: 'yung-ching',
  U_TRUST: 'u-trust',
  TAI_CHING: 'tai-ching',
  HOUSE_FUN: 'house-fun',
  ETWARM: 'etwarm',
  TAIWANTRADE: 'ttmegaexpo',
  YUNG_YI: 'yung-yi'
}
export const COLOR = {
  DEFAULT_THEME: 'pink',
  DEFAULT_MAIN_COLOR: '#FF6700',
  DEFAULT_SUB_COLOR: '#662e91',
  ETWARM_THEME: 'etwarm-red',
  ETWARM_MAIN_COLOR: '#e60012',
  ETWARM_SUB_COLOR: '#f49d37',
  BLACK_MAIN_COLOR: '#000000',
  BLACK_SUB_COLOR: '#bcbdc1',
  BLUE_MAIN_COLOR: '#49b9fb',
  BLUE_SUB_COLOR: '#a3d5ff',
  GREEN_MAIN_COLOR: '#61be6b',
  GREEN_SUB_COLOR: '#c3d898',
  ORANGE_MAIN_COLOR: '#f95738',
  ORANGE_SUB_COLOR: '#ffd07b',
  YELLOW_MAIN_COLOR: '#fcbf49',
  YELLOW_SUB_COLOR: '#ffd5c2'
}
export const BUILDING = {
  SHOW_COMMENT: true,
  SHOW_SEARCH: true,
  SHOW_CONTACT_INFO: true,
  SHOW_POWERED_BY: true,
  LOGO_SIZE: 125
}
export const DEFAULT_LOGO_SIZE = 60
export const WHITE_LABEL_CELINE = false

export const CATEGORY_OPTIONS = [
  null,
  'product',
  'company',
  'livetour'
]
export const DISPLAY_SEARCH_RESULT_QTY = 15 // 搜尋結果預設顯示數量
export const KRPANO_SETTING = {
  speed: {
    slow: 200 / 360, // autorotate
    average: 100 / 360,
    fast: 50 / 360, // autopilot
    instant: 0.5 / 360
  },
  time: {
    autoRotate: 200,
    autoStartAutoRotate: 5
  }
}

export const yachtBuildingId = '57e6aea7-c5c8-4320-a2d2-fd67ae5381fc'

export const loadingBarCustomConfig = {
  videoSrc: 'https://vrmaker.istaging.com/00000photoUpload/0224_Loading.mp4',
  headQuarterTitle: 'ttmegaexpo'
}

// Support parsing below urls
// https://www.youtube.com/watch?v=072tU1tamd0
// https://youtu.be/072tU1tamd0
// https://www.youtube.com/embed/072tU1tamd0
// https://www.youtube.com/v/072tU1tamd0
// https://www.youtube-nocookie.com/embed/072tU1tamd0
export const YOUTUBE_URL_PATTERN = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i

// Support parsing below urls
// https://www.twitch.tv/RSLeauge
// https://www.twitch.tv/RSLeauge/videos
export const TWITCH_PATTERN = /twitch.tv\/(\w+)/i

export const silentAudio = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
